import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@daater/ui';

type BaseScreenProps = {
  title: string;
  description?: string;
};

const BaseScreen: React.FC<BaseScreenProps> = ({ title, description }) => {
  return (
    <section className="mx-auto flex w-full max-w-5xl flex-col gap-4">
      <div className="rounded-lg border border-pale-grey-three bg-white p-6 shadow-sm">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-semibold text-charcoal-grey">{title}</h1>
          <Button variant="secondary" size="sm">
            Next step
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
        {description ? <p className="mt-2 text-sm text-slate">{description}</p> : null}
      </div>
    </section>
  );
};

export default BaseScreen;
